import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=fa72ceca&scoped=true"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./SendMessageDialog.vue?vue&type=style&index=0&id=fa72ceca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa72ceca",
  null
  
)

export default component.exports